export interface GlossaryEntry {
  term: string;
  definition: string;
}

export const glossary: GlossaryEntry[] = [
  {
    term: 'State-based conflict',
    definition: 'Armed conflict where at least one party is a government. Includes civil wars (government vs rebel group) and interstate wars (government vs government).',
  },
  {
    term: 'Non-state conflict',
    definition: 'Armed violence between organised groups where neither side is a government — e.g. clashes between rebel factions, ethnic militias, or criminal gangs.',
  },
  {
    term: 'One-sided violence',
    definition: 'Deliberate attacks on civilians by an organised group (government or non-state). Includes massacres, ethnic cleansing, and terrorism targeting civilians.',
  },
  {
    term: 'Major war',
    definition: 'A conflict causing 10,000 or more fatalities per year. These are the deadliest active conflicts in the world.',
  },
  {
    term: 'Minor war',
    definition: 'A conflict causing between 1,000 and 9,999 fatalities per year. Serious and sustained, but below the threshold of a major war.',
  },
  {
    term: 'Conflict',
    definition: 'An armed clash causing between 100 and 999 fatalities per year. Often chronic, low-intensity violence such as insurgencies or communal clashes.',
  },
  {
    term: 'Skirmish',
    definition: 'Armed clashes causing fewer than 100 fatalities per year. Includes border incidents, sporadic guerrilla attacks, and residual violence from ended wars.',
  },
  {
    term: 'Insurgency',
    definition: 'An organised rebellion against a government, typically using guerrilla tactics — ambushes, IEDs, hit-and-run attacks — rather than conventional warfare.',
  },
  {
    term: 'UCDP',
    definition: 'Uppsala Conflict Data Program — the world\'s leading academic data source on organised violence, maintained by Uppsala University in Sweden since 1946.',
  },
  {
    term: 'ACLED',
    definition: 'Armed Conflict Location & Event Data Project — a non-profit that collects real-time data on political violence and protest events worldwide.',
  },
  {
    term: 'IDP',
    definition: 'Internally Displaced Person — someone forced to flee their home by conflict or disaster but who remains within their country\'s borders (unlike refugees who cross borders).',
  },
  {
    term: 'Fatalities',
    definition: 'Deaths directly caused by organised violence — battle deaths, civilian casualties from attacks, and extrajudicial killings. Does not include indirect deaths from famine or disease caused by conflict.',
  },
  {
    term: 'Intensity level',
    definition: 'A measure of how severe a conflict is, based on annual fatality count. UCDP uses two levels: minor (25-999 deaths/year) and war (1,000+ deaths/year).',
  },
  {
    term: 'Ceasefire',
    definition: 'A temporary or permanent halt to fighting, agreed by the warring parties. Can be formal (signed agreement) or informal (de facto pause). Does not mean the conflict is resolved.',
  },
  {
    term: 'Territorial dispute',
    definition: 'A conflict over control of land or borders. Can involve sovereign states (e.g. India-Pakistan over Kashmir) or separatist groups seeking independence.',
  },
  {
    term: 'Battle-related deaths',
    definition: 'Deaths resulting directly from combat between organised parties — soldiers, militants, and civilians caught in crossfire. The primary metric for measuring conflict intensity.',
  },
];

export function lookupTerm(term: string): GlossaryEntry | undefined {
  const lower = term.toLowerCase();
  return glossary.find(g => g.term.toLowerCase() === lower);
}
